import { render, staticRenderFns } from "./shopType.vue?vue&type=template&id=2968e006"
import script from "./shopType.vue?vue&type=script&lang=js"
export * from "./shopType.vue?vue&type=script&lang=js"
import style0 from "./shopType.vue?vue&type=style&index=0&id=2968e006&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2968e006')) {
      api.createRecord('2968e006', component.options)
    } else {
      api.reload('2968e006', component.options)
    }
    module.hot.accept("./shopType.vue?vue&type=template&id=2968e006", function () {
      api.rerender('2968e006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/shopType.vue"
export default component.exports